
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'verify-token-page',
});
